<template>
  <main class="marketing campaign center">
    <div v-if="noPuzzlesAvailable" class="empty">
      <article>
        <p>{{ $t('No more campaigns available.') }}</p>
      </article>
    </div>

    <div v-else>
      <p class="align-center">{{ $t('Please select a campaign level:') }}</p>
      <ul class="actions center">
        <li v-for="(label, value) in levels" :key="`level-${value}`">
          <button type="button" @click.prevent="selectLevel(value)">
            {{ label }}
          </button>
        </li>
      </ul>
    </div>
  </main>
</template>

<script setup lang="ts">
import { router } from '@inertiajs/vue3'
import { computed } from 'vue'

import GameLayout from '/@front:layouts/game.vue'
import { error } from '/@front:shared/notifications'

defineOptions({
  layout: [GameLayout],
})

const props = defineProps<{
  levels: Record<string, string>
}>()

const noPuzzlesAvailable = computed(() => Object.keys(props.levels).length === 0)

const selectLevel = (level: string) => {
  router.post(
    location.pathname,
    {
      level: level,
    },
    {
      onError: () => {
        error('Failed to perform action.')
      },
    },
  )
}
</script>
